import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { LOGIN_URL } from "../services/api";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Load user from localStorage on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    const user = JSON.parse(localStorage.getItem("user"));
    if (token && user) {
      setLoggedInUser(user);
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    }
    setIsLoading(false); // 👈 Set loading false once done
  }, []);

  // Login function with API call
  const login = async (email, password) => {
    try {
      const response = await axios.post(`${LOGIN_URL}`, {
        email,
        password,
      });

      const { data } = response.data;
      const token = data.token;
      const user = data.user;
      const company = data.company;

      // Store in localStorage
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      if (company) {
        localStorage.setItem("company", JSON.stringify(company));
      }
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      setLoggedInUser(user);
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.message || "Login failed",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    delete axios.defaults.headers.common["Authorization"];
    setLoggedInUser(null);
  };

  return (
    <UserContext.Provider
      value={{ loggedInUser, setLoggedInUser, login, logout, isLoading }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
